import React from 'react';
import { useNavigate } from 'react-router-dom';

const WhyThanjavur: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 pt-[160px]">
      {/* Hero Section */}
    
      
      <section className="relative text-white py-20 bg-gradient-to-r from-[#041230] to-[#032744] bg-opacity-50">
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">🌾 Why Thanjavur?</h1>
          <p className="text-xl md:text-2xl max-w-full mx-auto whitespace-nowrap overflow-hidden text-ellipsis">
            Discover the cultural heart of Tamil Nadu and your next investment opportunity
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            
            {/* Cultural Heritage & Tourism */}
            <div className="bg-white rounded-xl shadow-lg p-8">
              <div className="flex items-center mb-6">
                <div className="bg-blue-100 p-3 rounded-full mr-4">
                  <svg className="w-8 h-8 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">1. Cultural Heritage & Tourism</h3>
              </div>
              <p className="text-gray-600 leading-relaxed">
                Thanjavur, also known as Tanjore, is the cultural heart of Tamil Nadu, home to the UNESCO World Heritage site Brihadisvara Temple. Its deep-rooted Chola and Maratha history makes it a tourism magnet, giving properties here unique charm and value.
              </p>
            </div>

            {/* Education & Healthcare Hub */}
            <div className="bg-white rounded-xl shadow-lg p-8">
              <div className="flex items-center mb-6">
                <div className="bg-green-100 p-3 rounded-full mr-4">
                  <svg className="w-8 h-8 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z"/>
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">2. Education & Healthcare Hub</h3>
              </div>
              <p className="text-gray-600 leading-relaxed">
                Despite its modest size, Thanjavur hosts four universities and several top-tier colleges and hospitals. This academic and medical ecosystem attracts professionals, students, and faculty—ensuring consistent housing demand.
              </p>
            </div>

            {/* Infrastructure & Connectivity */}
            <div className="bg-white rounded-xl shadow-lg p-8">
              <div className="flex items-center mb-6">
                <div className="bg-purple-100 p-3 rounded-full mr-4">
                  <svg className="w-8 h-8 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd"/>
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">3. Infrastructure & Connectivity</h3>
              </div>
              <p className="text-gray-600 leading-relaxed">
                Well-connected via NH 83 & 36, and just 56 km from Trichy's international airport, Thanjavur enjoys both accessibility and tranquility. Government Smart City investments (₹974+ crore) are improving bus stands, drainage, parks, and more—uplifting overall livability.
              </p>
            </div>

            {/* Green Environment & Natural Resources */}
            <div className="bg-white rounded-xl shadow-lg p-8">
              <div className="flex items-center mb-6">
                <div className="bg-emerald-100 p-3 rounded-full mr-4">
                  <svg className="w-8 h-8 text-emerald-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">4. Green Environment & Natural Resources</h3>
              </div>
              <p className="text-gray-600 leading-relaxed">
                Known as the "Rice Bowl of Tamil Nadu," Thanjavur boasts fertile alluvial soil and year-round water availability from the Cauvery river system. Areas like Punnainallur offer lush greenery, cleaner air, and ideal conditions for landscaping and sustainable living.
              </p>
            </div>

            {/* Affordable & High Quality of Life */}
            <div className="bg-white rounded-xl shadow-lg p-8">
              <div className="flex items-center mb-6">
                <div className="bg-yellow-100 p-3 rounded-full mr-4">
                  <svg className="w-8 h-8 text-yellow-600" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z"/>
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z" clipRule="evenodd"/>
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">5. Affordable & High Quality of Life</h3>
              </div>
              <p className="text-gray-600 leading-relaxed">
                Thanjavur offers the perfect blend of affordability and comfort—lower living costs, peaceful atmosphere, low crime rates, and a close-knit community life centered on festivals and temples.
              </p>
            </div>

            {/* Booming Real Estate Potential */}
            <div className="bg-white rounded-xl shadow-lg p-8">
              <div className="flex items-center mb-6">
                <div className="bg-red-100 p-3 rounded-full mr-4">
                  <svg className="w-8 h-8 text-red-600" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"/>
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">6. Booming Real Estate Potential</h3>
              </div>
              <p className="text-gray-600 leading-relaxed">
                With rising interest in Tier-2/3 cities post-COVID, Thanjavur's property prices remain accessible while showing strong appreciation potential. Government initiatives and economic growth plans for Tamil Nadu enhance its realty outlook.
              </p>
            </div>

          </div>

          {/* Punnainallur Section */}
          <div className="mt-16 bg-gradient-to-r from-green-50 to-blue-50 rounded-2xl p-12">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">7. Punnainallur – The Ideal Suburb</h2>
              <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
                Just outside the city center, Punnainallur is serene yet accessible. It is spiritually significant (home to the famous Mariamman Temple), well-connected, and ideal for premium apartment projects surrounded by greenery and temple culture.
              </p>
            </div>
          </div>

          {/* Target Buyers Section */}
          <div className="mt-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-12">8. Target Buyers</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              
              <div className="text-center p-6 bg-white rounded-xl shadow-lg">
                <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"/>
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Local Families</h3>
                <p className="text-gray-600">Looking for modern, gated communities in a safe, cultural setting.</p>
              </div>

              <div className="text-center p-6 bg-white rounded-xl shadow-lg">
                <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd"/>
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">NRIs</h3>
                <p className="text-gray-600">Seeking investment and retirement homes with spiritual proximity.</p>
              </div>

              <div className="text-center p-6 bg-white rounded-xl shadow-lg">
                <div className="bg-purple-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4zM18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z"/>
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Investors</h3>
                <p className="text-gray-600">Attracted by rental yields and appreciation prospects.</p>
              </div>

              <div className="text-center p-6 bg-white rounded-xl shadow-lg">
                <div className="bg-yellow-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-yellow-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd"/>
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">First-Time Buyers</h3>
                <p className="text-gray-600">Young professionals or returnees preferring affordable luxury.</p>
              </div>

            </div>
          </div>

          {/* Regional Development Trend */}
          <div className="mt-16 bg-gradient-to-r from-blue-900 to-blue-700 text-white rounded-2xl p-12">
            <div className="text-center">
              <h2 className="text-3xl md:text-4xl font-bold mb-6">9. Regional Development Trend</h2>
              <p className="text-xl max-w-4xl mx-auto leading-relaxed">
                With Trichy, Kumbakonam, and Nagapattinam seeing growth, Thanjavur benefits from spillover effects. Industrial corridors, government incentives, and infrastructure upgrades place Thanjavur at the forefront of Tamil Nadu's next-tier city boom.
              </p>
            </div>
          </div>

          {/* Call to Action */}
          <div className="mt-16 text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Ready to Invest in Thanjavur?</h2>
            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
              Discover premium properties in this culturally rich and rapidly developing city.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={() => navigate('/properties')} 
                className="bg-blue-900 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-800 transition-colors"
              >
                View Properties
              </button>
              <button 
                onClick={() => navigate('/contact')} 
                className="border-2 border-blue-900 text-blue-900 px-8 py-3 rounded-lg font-semibold hover:bg-blue-900 hover:text-white transition-colors"
              >
                Contact Us
              </button>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
};

export default WhyThanjavur;